import ReusableButton from 'components/commom/Button';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import checkIcon from 'assets/images/WithoutLogin/Checkbox.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ClearTokenRedirectLogin } from 'utils/general';
import { FormattedMessage } from 'react-intl';
import { doctorChangePlan, doctorSubscription } from 'routes/AppUrls';
import Shimmer from 'components/commom/Shimmer';
import LocalStorageManager from 'managers/LocalStorageManger';
import moment from 'moment';
import CommonModal from 'components/commom/Modal';
import { postCancel } from 'store/cancelSubscription/cancelSubscriptionAction';
import { getProfileSectionData } from 'store/doctorProfileSection/doctorProfileSectionAction';
import CommonToast from 'components/commom/CommonToast';

const DoctorCancel = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const params = useParams();
  const { showToast } = CommonToast();
  const [cancelModal, setCancelModal] = useState(false);

  const profileData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const loading = useSelector(
    (state) => state?.profileSectionDataReducer?.loading
  );

  const loadingButton = useSelector(
    (state) => state?.postCancelReducer?.loading
  );

  useEffect(() => {
    if (params?.token) {
      LocalStorageManager.setItem('token', params?.token);
    }
  }, []);

  const ProductDescription = ({ description }) => {
    const stripHtmlTags = (html) => {
      if (!html) return [];
      return html
        .replace(/<[^>]*>/g, '')
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '' && line !== '&nbsp;');
    };

    const lines = stripHtmlTags(description);

    const capitalizeFirstLetter = (line) => {
      if (line.length === 0) return line;
      return line.charAt(0).toUpperCase() + line.slice(1).toLowerCase();
    };

    const highlightKeywords = (text) => {
      const keywords = [
        'Name',
        'Title',
        'Practice location',
        'Listed after advanced in roster',
      ];

      keywords.forEach((keyword) => {
        const regex = new RegExp(`(${keyword})`, 'gi');
        text = text.replace(
          regex,
          '<span style="font-size:14px; font-weight:400;" class="family_outfit_regular_400">$1</span>'
        );
      });

      text = text.replace(/:\s*([^,]*),/g, ': $1');
      return text;
    };

    return (
      <div>
        {lines.map((line, index) =>
          line && line !== '&nbsp;' ? (
            <div key={index} className="flex items-start mb-2">
              {/* <Image src={checkIcon} alt="checkIcon" className="mt-1 mr-2" /> */}
              <p
                className="family_outfit_regular_400"
                style={
                  index === 0 ? { margin: 0 } : { fontSize: '16px', margin: 0 }
                }
                dangerouslySetInnerHTML={{
                  __html: highlightKeywords(line),
                }}
              />
            </div>
          ) : null
        )}
      </div>
    );
  };

  const handleCancelModal = () => {
    setCancelModal(true);
  };

  const handleCloseModal = () => {
    setCancelModal(false);
  };

  const handleCancelProcess = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setCancelModal(false);
        profileValue();
        showToast(res?.message, 'success');
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      subscription_id: profileData?.subscription?.subscribed_id,
    };
    dispatch(postCancel(external, body));
  };

  useEffect(() => {
    profileValue();
  }, []);

  const profileValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        if (res?.data?.subscription === null) {
          navigate(doctorSubscription(locale));
        }
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {},
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProfileSectionData(external));
  };

  const hanldeNavigateChangePlan = () => {
    navigate(
      doctorChangePlan(
        locale,
        profileData?.subscription?.subscription_plan?.subscription_plan_id,
        LocalStorageManager.getItem('token')
      )
    );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <Row className="m-0">
            <Col lg={10} xl={10} xxl={10} className=" p-0">
              <div className="pt-10 lg:pt-0">
                <div class="p-16 sm:p-24 bg-light-100 border-1 bColor-EFE3D7 ">
                  <div className="pb-10 fs-24 family_outfit_semiBold_600 lh-312 fc-292D32 border-b bColor-EFE3D7">
                    Current Plans
                  </div>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-18 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Plan Type :
                    </div>
                    {loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {`${
                          profileData?.subscription?.subscription_plan?.product
                            ?.name
                        } ${profileData?.subscription?.subscription_plan?.name}`}
                      </div>
                    )}
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-18 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Plan Price :
                    </div>
                    {profileData?.subscription?.subscription_plan?.price ===
                    undefined ? (
                      ''
                    ) : loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {`$ ${profileData?.subscription?.subscription_plan?.price}`}
                      </div>
                    )}
                  </Stack>
                  <Row className="m-0">
                    <Col
                      xs={6}
                      sm={4}
                      md={3}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className="p-0"
                    >
                      <div className="fs-18 family_outfit_medium_500 lh-30 fc-A4AAB2 pt-20">
                        Active since
                      </div>
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {loading ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          moment(profileData?.subscription?.valid_from).format(
                            'DD MMM YYYY'
                          )
                        )}
                      </div>
                    </Col>
                    <Col xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className="fs-18 family_outfit_medium_500 lh-30 fc-A4AAB2 pt-20">
                        Ending date
                      </div>
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {loading ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          moment(
                            profileData?.subscription?.next_billing_time
                          ).format('DD MMM YYYY')
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div className="pt-10 fs-16 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                    Description
                  </div>
                  <div className="pt-10">
                    {loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <ProductDescription
                        description={
                          profileData?.subscription?.subscription_plan
                            ?.description
                        }
                      />
                    )}
                  </div>
                  <Row className="m-0 flex justify-end">
                    <Col md={4} lg={4} xl={3} xxl={3}>
                      <div className="pt-10 md:pt-0">
                        <ReusableButton
                          fullWidth={true}
                          variant="outlined"
                          color="#375241"
                          fontSize="16px"
                          fontWeight="600"
                          padding="12px 50px"
                          height="44px"
                          bgColor="transparent"
                          brColor="#375241  "
                          fontFamily="outfit_semiBold"
                          onClick={() => handleCancelModal()}
                        >
                          <FormattedMessage id="Cancel Plan" />
                        </ReusableButton>
                      </div>
                    </Col>
                    <Col md={4} lg={4} xl={3} xxl={3}>
                      <div className="pt-20 md:pt-0">
                        <ReusableButton
                          fullWidth={true}
                          variant="outlined"
                          color="#F5F5F5"
                          fontSize="16px"
                          fontWeight="600"
                          padding="12px 50px"
                          height="44px"
                          bgColor="#375241"
                          brColor="#375241  "
                          fontFamily="outfit_semiBold"
                          onClick={() => hanldeNavigateChangePlan()}
                        >
                          <FormattedMessage id="Change Plan" />
                        </ReusableButton>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'700px'}
        modalActive={cancelModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12} className="text-center">
                <div className="fs-24 fc-292D32 family_outfit_semiBold_600">
                  Are you sure you want to cancel your plan?
                </div>
              </Col>
              <Row className="m-0 flex justify-end">
                <Col md={6}>
                  <div className="pt-10 md:pt-20">
                    <ReusableButton
                      fullWidth={true}
                      variant="outlined"
                      color="#375241"
                      fontSize="16px"
                      fontWeight="600"
                      padding="12px 50px"
                      height="44px"
                      bgColor="transparent"
                      brColor="#375241  "
                      fontFamily="outfit_semiBold"
                      onClick={() => handleCloseModal()}
                    >
                      <FormattedMessage id="Continue Subscription" />
                    </ReusableButton>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="pt-20 md:pt-20">
                    <ReusableButton
                      fullWidth={true}
                      variant="outlined"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="600"
                      padding="12px 50px"
                      height="44px"
                      bgColor="#375241"
                      brColor="#375241  "
                      fontFamily="outfit_semiBold"
                      onClick={() => {
                        !loadingButton && handleCancelProcess();
                      }}
                      loading={loadingButton}
                    >
                      <FormattedMessage id="Cancel Subscription" />
                    </ReusableButton>
                  </div>
                </Col>
              </Row>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default DoctorCancel;
